import React from 'react';
import colors from '../../util/colors';

interface AddSharedFilesIconProps {
  color?: string;
}

function AddSharedFilesIcon({color = colors.blue}: AddSharedFilesIconProps) {
  return (
    <svg width="18px" height="18px" viewBox="0 0 18 18">
      <title></title>
      <g
        id="08---Consultas-Online"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g
          id="MY-D-08-03-02"
          transform="translate(-1194.000000, -932.000000)"
          fill={color}
          fillRule="nonzero">
          <g id="modal" transform="translate(150.000000, 60.000000)">
            <g id="Group" transform="translate(58.000000, 512.000000)">
              <g
                id="buttons/menu_internal-copy-2"
                transform="translate(524.000000, 357.000000)">
                <g
                  id="cards/close_icon"
                  transform="translate(462.000000, 3.000000)">
                  <path
                    d="M9,0 C9.72179651,0 10.3106218,0.56937004 10.341923,1.28345171 L10.3432317,1.34328451 L10.3429688,7.65675 L16.6567155,7.65676827 C17.378512,7.65676827 17.9673373,8.22608557 17.9986871,8.94016762 L18,9 C18,9.72179651 17.43063,10.3106218 16.7165483,10.341923 L16.6567155,10.3432317 L10.3429688,10.3429687 L10.3432317,16.6567155 C10.3432317,17.378512 9.77391443,17.9673373 9.05983238,17.9986871 L9,18 C8.27820349,18 7.68937819,17.43063 7.65807703,16.7165483 L7.65676827,16.6567155 L7.65675,10.3429687 L1.34328451,10.3432317 C0.621488009,10.3432317 0.0326626881,9.77391443 0.00131292866,9.05983238 L0,9 C0,8.27820349 0.56937004,7.68937819 1.28345171,7.65807703 L1.34328451,7.65676827 L7.65675,7.65675 L7.65676827,1.34328451 C7.65676827,0.621488009 8.22608557,0.0326626881 8.94016762,0.00131292866 L9,0 Z"
                    id="Path"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default AddSharedFilesIcon;
